import wx from 'weixin-js-sdk'

/**
 * 返回当前的运行环境 开发dev、日常daily、预发pre、线上publish
 */
export function env(needNum = false) {
  return (process.env.VUE_APP_BUILD_ENV === 'dev' && needNum) ? process.env.VUE_APP_BUILD_ENV_NUM : process.env.VUE_APP_BUILD_ENV
}


/**
 * 是否在微信环境
 */
export function isWxBrowser() {
  let u = window.navigator.userAgent.toLowerCase();
  return (/micromessenger/i.test(u))
}

export function isMobile(){
  if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
   return true; // 移动端
  }else{
   return false; // PC端
  }
}
/**
* 是否在微信小程序中
*/
export let isMiniprogram = (call, timeout = 3000) => {
  // 只在非线上环境添加超时控制
  if (process.env.VUE_APP_BUILD_ENV !== 'publish') {
    // 创建超时 Promise
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => {
        // reject(new Error('获取小程序环境超时'))
        _(false, wx)
      }, timeout)
    })

    // 创建实际检测环境的 Promise
    const detectPromise = new Promise((resolve, reject) => {
      wx.miniProgram.getEnv(res => {
        resolve(res.miniprogram)
        if (window.__isMiniprogram === undefined) {
          window.__isMiniprogram = res.miniprogram;
        }
        call && call(res.miniprogram, wx)
      }, rea => {
        call && call(rea.miniprogram, wx)
        reject(rea)
      })
    })

    // 非线上环境使用 Promise.race
    return Promise.race([detectPromise, timeoutPromise])
  }
  return new Promise((resolve, reject) => {
    if (!isMobile()) {
      console.log('!isMobile()')
      resolve(false)
    } else {
    // 线上环境保持原有逻辑
    wx.miniProgram.getEnv(res => {
      resolve(res.miniprogram)
      if (window.__isMiniprogram === undefined) {
        window.__isMiniprogram = res.miniprogram;
      }
      call && call(res.miniprogram, wx)
    }, rea => {
      call && call(rea.miniprogram, wx)
    })
  }
  })
}

/**
 * 是否在ios环境
 */
export function isIosBrowser() {
  let u = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/i.test(u)
}

/**
 * 是否在android环境
 */
export function isAndroidBrowser() {
  let u = window.navigator.userAgent.toLowerCase();
  return (/android/i.test(u))
}

/**
 * 是否在开发环境
 */
export function isDevelopment() {
  //开发环境判断
  return process.env.VUE_APP_BUILD_ENV !== 'publish'
}

/**
 * 是否在本地环境
 */
export function isLocal() {
  return window.location.href.indexOf('kshdoctor') < 0
}
